module.exports = __webpack_public_path__ + "img/jacquard.9a8553af.svg";